<template>
  <main class="main" ref="artist" v-if="artist" :key="artist.uid">
    <div class="page-title">Works</div>
    <div class="selected-work" v-if="selected !== null">
      <img
        v-if="selected.url"
        v-lazy="selected.url"
        v-lazy:set="selected.srcset"
        :alt="artist.title"
      />
      <div class="caption" v-html="selected.caption"></div>
      <div class="description" v-html="selected.description"></div>
      <!-- {{ selected.description }} -->
    </div>
    <div class="works">
      <div
        class="work"
        v-for="(image, index) in artist.images"
        :key="index"
        @click="
          selected = image;
          scrollTop();
        "
      >
        <img v-lazy="image.url" :data-srcset="image.srcset" :alt="artist.title" />
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "artist",
  metaInfo() {
    return {
      title: "– " + this.artist.title,
    };
  },
  computed: mapState(["artist"]),
  data() {
    return {
      selected: null,
    };
  },
  created() {
    this.$store.state.artist = [];
    this.$store.dispatch("loadArtist", this.$route.params.id);
  },
  methods: {
    scrollTop() {
      this.$refs.artist.scroll({
        top: 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/defaults.scss";

.page-title {
  margin-bottom: calc(var(--gap) / 6);
}
img {
  object-fit: contain;
  max-height: 50vh;
  object-position: top left;
}
.caption {
  margin-top: calc((var(--line-height) * var(--font-size)) / 6);
  font-size: calc(var(--font-size) / 1.75);
  margin-bottom: var(--gap);
}
.description {
  font-size: 2.4rem;
}
.selected-work {
  padding-bottom: 6rem;
}
.works {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 3.45rem;
  .work {
    cursor: pointer;
  }
}
</style>
